import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { Rule } from '../base/mutation-rules';
import { BaseMutation } from '../base/base-mutation';
import { DataType, PAGE_DATA_TYPES } from '../../data';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidGroupMutationData, IValidUngroupMutationData } from '../base/valid-mutation-data';

export class GroupMutation extends BaseMutation<PresentationDataModel, IValidGroupMutationData> {
    public readonly type: MutationType = MutationType.Group;

    public apply(presentation: PresentationDataModel) {
        const { groupShapeId, shapeIds, pageId } = this.data;

        let { parentId, index } = this.data;
        const shapeTree = presentation.store.models.get(pageId, ...PAGE_DATA_TYPES)?.store.getShapeTree();
        if (!parentId && shapeTree) {
            parentId = shapeTree.id;
            index = shapeIds.length ? shapeTree.store.shapeList.findIndexById(shapeIds[0]) : shapeTree.shapeList.length;
        }

        const parentShape = presentation.store.models.get(parentId, DataType.GroupShape);
        assert(parentShape, 'group shape should not exist');

        parentShape.store.groupShapesOfRange(groupShapeId, index, shapeIds.length);
    }

    public invert(): [IValidUngroupMutationData] {
        const { pageId, groupShapeId, shapeIds, parentId, index } = this.data;
        return [
            {
                type: MutationType.Ungroup,
                pageId,
                groupShapeId,
                shapeIds,
                parentId,
                index,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeIds } = this.data;
        let { parentId, index } = this.data;

        const shapeTree = presentation.store.models.get(pageId, ...PAGE_DATA_TYPES)?.store.getShapeTree();
        if (!parentId && shapeTree) {
            parentId = shapeTree.id;
            index = shapeIds.length ? shapeTree.store.shapeList.findIndexById(shapeIds[0]) : shapeTree.shapeList.length;
        }

        return Rule.every(
            Rule.shape.should.existInPage(presentation, parentId, pageId),
            Rule.shape.should.matchShapeListInPosition(presentation, parentId, index, shapeIds),
        );
    }
}
